export default "__VITE_PUBLIC_ASSET__dcf0ae9d__"